enum DriveReservationRequestType {
    GROUP = '1',
    CLASS = '2',
    ASSET = '3',
    MANUAL = '4',
}

export default DriveReservationRequestType;